import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useState, useEffect } from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Nav(props) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [openMobileMenu, setOpenMobileMenu] = useState(null);

  const navigation = [
   {/* { name: 'Bon cadeaux', href: 'https://www.kalendes.com/site/instantbienetrecoralie/gift', target: '_blank', current: false },
    {
      name: 'Nos soins',
      dropdown: [
        { name: 'Aqua faciale', href: 'https://www.kalendes.com/site/instantbienetrecoralie/link/ARTICLE/1987750', target: '_blank' },
        { name: 'Épilation durable', href: 'https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190080', target: '_blank' },
        { name: 'Soins Enfants', href: 'https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/330594', target: '_blank' },
        { name: 'Manucure & Pédicure', href: '#', target: '_blank' },
      ]
    },
    {
      name: 'Nos massages',
      dropdown: [
        { name: 'Massage Californien', href: '#', target: '_blank' },
        { name: 'Massage Suédois', href: '#', target: '_blank' },
        { name: 'Réflexologie Plantaire', href: '#', target: '_blank' },
        { name: 'Rituel Duo', href: '#', target: '_blank' },
      ]
    }, */},
    { name: 'Réserver', href: 'https://www.kalendes.com/site/instantbienetrecoralie/reserve', target: '_blank' },
    { name: 'Notre équipe', href: '#team', current: false, onClick: () => props.scroll('team') },
    { name: 'Contactez-nous', href: '#contact', current: false, onClick: () => props.scroll('contact') },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.pageYOffset > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuClick = (itemName, hasDropdown, closeMenu) => {
    if (hasDropdown) {
      setOpenMobileMenu(openMobileMenu === itemName ? null : itemName);
    } else {
      closeMenu();
    }
  };

  return (
    <Disclosure as="nav" className={classNames(
      'fixed w-full z-20 top-0 left-0 transition-colors duration-300',
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    )}>
      {({ open, close }) => (
        <>
          <div className='mx-auto px-4 sm:px-6 lg:px-8'>
            <div className="relative flex h-16 items-center justify-between">
              <a href="/" className="flex-shrink-0">
                <img className='h-12 w-auto' src='/images/logocoralie.png' alt='Instant bien être' />
              </a>
              <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className={classNames('block h-6 w-6', isScrolled ? 'text-black' : 'text-white')} aria-hidden="true" />
                  ) : (
                    <Bars3Icon className={classNames('block h-6 w-6', isScrolled ? 'text-black' : 'text-white')} aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="hidden sm:flex sm:items-center sm:ml-6">
                <div className="flex space-x-4">
                  {navigation.map((item) => (
                    <div 
                      key={item.name}
                      className="relative"
                      onMouseEnter={() => item.dropdown && setHoveredMenu(item.name)}
                      onMouseLeave={() => item.dropdown && setHoveredMenu(null)}
                    >
                      <a
                        target={item.target}
                        href={item.href || '#'}
                        onClick={(e) => {
                          if (item.dropdown) {
                            e.preventDefault();
                          } else if (item.onClick) {
                            item.onClick();
                          }
                        }}
                        className={classNames(
                          'px-3 py-2 text-sm font-medium cursor-pointer',
                          hoveredMenu === item.name
                            ? classNames(
                                isScrolled ? 'bg-gray-100' : 'bg-white',
                                'text-black rounded-t-md'
                              )
                            : classNames(
                                isScrolled ? 'text-black hover:bg-gray-100' : 'text-white hover:bg-white hover:bg-opacity-10',
                                'rounded-md'
                              )
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                      {item.dropdown && hoveredMenu === item.name && (
                        <div className={classNames(
                          'absolute top-full left-1/2 -translate-x-1/2 w-56 rounded-b-md shadow-lg py-1 z-30',
                          isScrolled ? 'bg-gray-100' : 'bg-white'
                        )}>
                          {item.dropdown.map((subItem) => (
                            <a
                              key={subItem.name}
                              href={subItem.href}
                              target={subItem.target}
                              rel="noopener noreferrer"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
                            >
                              {subItem.name}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden bg-white">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <div key={item.name}>
                  <button
                    onClick={() => handleMobileMenuClick(item.name, !!item.dropdown, close)}
                    className='w-full text-left block rounded-md px-3 py-2 text-base font-medium text-black hover:bg-gray-100'
                  >
                    {item.name}
                  </button>
                  {item.dropdown && openMobileMenu === item.name && (
                    <div className="pl-4 mt-1 space-y-1">
                      {item.dropdown.map((subItem) => (
                        <a
                          key={subItem.name}
                          href={subItem.href}
                          target={subItem.target}
                          rel="noopener noreferrer"
                          className="block rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100"
                        >
                          {subItem.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
